// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-icon-menu-group[data-v-006bab39]{display:flex;flex-wrap:wrap}.app-icon-menu-group>*[data-v-006bab39]{width:20%}", ""]);
// Exports
module.exports = exports;
